<template>
  <base-page-layout title="Redes sociais" class="social-media">
    <v-skeleton-loader type="article, list-item-three-line@4" :loading="$apollo.queries.socialMedia.loading">
      <v-container fluid class="px-1">
        <v-card>
          <v-card-title class="section-title py-6"> Redes sociais </v-card-title>
          <v-card-subtitle class="subtitle">
            Configure aqui o endereço das suas redes sociais, o link inserido aqui é para onde seus usuários serão redirecionados quando clicarem nos ícones das
            redes sociais correspondentes. As redes sociais deixadas em branco não serão exibidas para seus consumidores.
          </v-card-subtitle>
          <v-card-text>
            <v-card class="media-card" flat>
              <v-card-title>
                <img :src="require('@/assets/icons/facebook-icon.png')" class="icon" />
                <span class="texto-corrido-destaque facebook"> Facebook </span>
              </v-card-title>
              <v-card-text>
                <v-text-field
                  v-model="facebookLink"
                  name="facebook"
                  outlined
                  hide-details
                  placeholder="https://facebook.com/"
                  label="Endereço da sua conta: "
                  @paste="handlePaste"
                ></v-text-field>
              </v-card-text>
            </v-card>
            <v-card class="media-card" flat>
              <v-card-title>
                <img :src="require('@/assets/icons/whats-icon.png')" class="icon" />
                <span class="texto-corrido-destaque whatsapp"> Whatsapp </span>
                <v-spacer />
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <div v-on="unitsVerification ? on : null">
                      <mf-button icon="add" label="Adicionar número" :disabled="unitsVerification" @click="addNewContactInfo" />
                    </div>
                  </template>
                  <div>
                    <span>Todas as lojas já possuem um número atrelado</span>
                  </div>
                </v-tooltip>
              </v-card-title>
              <v-card-text>
                <v-data-table class="table-card" :headers="headers" :items="whatsappList" disable-sort disable-filtering hide-default-footer disable-pagination>
                  <template v-slot:item="{ item }">
                    <tr>
                      <td>{{ formattedPhone(item.number) || '-' }}</td>
                      <td class="nowrap-row">
                        <v-tooltip top max-width="250" content-class="truncated-tooltip">
                          <template v-slot:activator="{ on }">
                            <span v-on="on">{{ getFormatedText(item.message) || '-' }}</span>
                          </template>
                          <span>{{ item.message || '-' }}</span>
                        </v-tooltip>
                      </td>
                      <td>
                        <v-tooltip right>
                          <template v-slot:activator="{ on }">
                            <span v-on="item.units.length > 2 ? on : null">{{ tableUnits(item.units) }}</span>
                          </template>
                          <div v-if="item.units.length > 2">
                            <span v-for="(unit, index) in unitsInfo(item.units)" :key="index">{{ unit }}<br /></span>
                          </div>
                        </v-tooltip>
                      </td>
                      <td>
                        <v-menu bottom origin="center center" transition="scale-transition">
                          <template v-slot:activator="{ on }">
                            <mf-button color="cinza-0" icon="more_vert" type="icon" v-on:click.native="on.click" />
                          </template>
                          <v-list>
                            <v-list-item @click="removeContact(item)">
                              <v-list-item-title>Remover</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="editContact(item)">
                              <v-list-item-title>Editar</v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
            <v-card class="media-card" flat>
              <v-card-title>
                <img :src="require('@/assets/icons/linkedin-icon.png')" class="icon" />
                <span class="texto-corrido-destaque linkedin"> Linkedin </span>
              </v-card-title>
              <v-card-text>
                <v-text-field
                  v-model="linkedinLink"
                  name="linkedin"
                  outlined
                  hide-details
                  placeholder="https://linkedin.com/company/"
                  label="Endereço da sua página: "
                  @paste="handlePaste"
                ></v-text-field>
              </v-card-text>
            </v-card>
            <v-card class="media-card" flat>
              <v-card-title>
                <img :src="require('@/assets/icons/insta-icon.png')" class="icon" />
                <span class="texto-corrido-destaque instagram"> Instagram </span>
              </v-card-title>
              <v-card-text>
                <v-text-field
                  v-model="instagramLink"
                  name="instagram"
                  outlined
                  hide-details
                  placeholder="https://instagram.com/"
                  label="Endereço da sua conta: "
                  @paste="handlePaste"
                ></v-text-field>
              </v-card-text>
            </v-card>
            <v-card class="media-card" flat>
              <v-card-title>
                <img :src="require('@/assets/icons/youtube-icon.png')" class="icon" />
                <span class="texto-corrido-destaque youtube"> Youtube </span>
              </v-card-title>
              <v-card-text>
                <v-text-field
                  v-model="youtubeLink"
                  name="youtube"
                  outlined
                  hide-details
                  placeholder="https://youtube.com/"
                  label="Endereço do seu canal: "
                  @paste="handlePaste"
                ></v-text-field>
              </v-card-text>
            </v-card>
            <v-card class="media-card" flat>
              <v-card-title>
                <img :src="require('@/assets/icons/twitter-icon.png')" class="icon" />
                <span class="texto-corrido-destaque twitter"> Twitter </span>
              </v-card-title>
              <v-card-text>
                <v-text-field
                  v-model="twitterLink"
                  name="twitter"
                  outlined
                  hide-details
                  placeholder="https://twitter.com/"
                  label="Endereço da sua conta: "
                  @paste="handlePaste"
                ></v-text-field>
              </v-card-text>
            </v-card>
            <v-card class="media-card" flat>
              <v-card-title>
                <img :src="require('@/assets/icons/tiktok-icon.png')" class="icon" />
                <span class="texto-corrido-destaque tiktok"> TikTok </span>
              </v-card-title>
              <v-card-text>
                <v-text-field
                  v-model="tiktokLink"
                  name="tiktok"
                  outlined
                  hide-details
                  placeholder="https://tiktok.com/@username"
                  label="Endereço do seu tiktok: "
                  @paste="handlePaste"
                ></v-text-field>
              </v-card-text>
            </v-card>
            <mf-action-buttons
              :primary-button="{
                text: 'Salvar alterações',
                action: save,
                isVisible: true,
                isLoading: loader,
              }"
              :extra-button="{
                text: 'Descartar alterações',
                action: restore,
                isVisible: true,
                isDisabled: false,
              }"
            />
          </v-card-text>
        </v-card>
      </v-container>
      <contact-modal
        :contact-dialog.sync="contactDialog"
        :contact-info="whatsappInfo"
        :hasSelectedWhatsapp="hasSelectedWhatsapp"
        @saveWhatsappInfo="updateWhatsappList"
      />
    </v-skeleton-loader>
  </base-page-layout>
</template>

<script>
import { QUERY_GET_SOCIAL_MEDIA, MUTATION_SOCIAL_MEDIA } from '../../../graphql'
import Swal from 'sweetalert2'
import { cloneDeep, truncate, isEqual } from 'lodash'
export default {
  name: 'RedesSociais',
  components: {
    BasePageLayout: () => import('@/components/BasePageLayout.vue'),
    ContactModal: () => import('@/modules/configuracoes/redes-sociais/views/pages/WhatsappUnitRegisterModal.vue'),
  },
  data: () => ({
    socialMedia: {
      facebook: '',
      instagram: '',
      whatsapp: [],
      youtube: '',
      linkedin: '',
      twitter: '',
    },
    whatsappInfo: {},
    headers: [
      {
        text: 'Número',
        width: '15%',
      },
      {
        text: 'Mensagem',
        width: '40%',
      },
      {
        text: 'Lojas',
        width: '40%',
      },
      {
        text: '',
        width: '5%',
      },
    ],
    contactDialog: false,
    loader: false,
  }),
  computed: {
    units() {
      return this.$store.getters.units
    },
    facebookLink: {
      get() {
        return this.socialMedia?.facebook
      },
      set(value) {
        this.socialMedia.facebook = value
      },
    },
    whatsappList() {
      return this.socialMedia?.whatsapp || []
    },
    hasSelectedWhatsapp() {
      return this.socialMedia?.whatsapp.some((w) => w.show_in_hotsite)
    },
    instagramLink: {
      get() {
        return this.socialMedia?.instagram
      },
      set(value) {
        this.socialMedia.instagram = value
      },
    },
    youtubeLink: {
      get() {
        return this.socialMedia?.youtube
      },
      set(value) {
        this.socialMedia.youtube = value
      },
    },
    linkedinLink: {
      get() {
        return this.socialMedia?.linkedin
      },
      set(value) {
        this.socialMedia.linkedin = value
      },
    },
    twitterLink: {
      get() {
        return this.socialMedia?.twitter
      },
      set(value) {
        this.socialMedia.twitter = value
      },
    },
    tiktokLink: {
      get() {
        return this.socialMedia?.tiktok
      },
      set(value) {
        this.socialMedia.tiktok = value
      },
    },
    unavailableUnits() {
      return this.socialMedia?.whatsapp?.reduce((acc, current) => acc.concat(current.units), []) || []
    },
    unitsVerification() {
      return isEqual(this.units.map((unit) => unit.id_erp).sort(), cloneDeep(this.unavailableUnits)?.sort())
    },
  },
  apollo: {
    socialMedia: {
      query: QUERY_GET_SOCIAL_MEDIA,
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'no-cache',
    },
  },
  mounted() {
    this.$store.dispatch('getStates', ['fetchUnits'])
  },
  methods: {
    handlePaste(event) {
      const clipboardData = event.clipboardData.getData('text')
      if (clipboardData.match(/https/g || [])) {
        this[`${event.target.name}Link`] = clipboardData
      } else {
        this.prefixValidation(clipboardData, event.target.name)
      }
      event.preventDefault()
    },
    async save() {
      this.loader = true
      delete this.socialMedia.__typename
      if (this.socialMedia.whatsapp) {
        this.socialMedia.whatsapp.forEach((whatsapp) => delete whatsapp.__typename)
      }
      Object.entries(this.socialMedia).forEach((entry) => {
        if (entry[1] === null) {
          this.socialMedia[entry[0]] = entry[0] === 'whatsapp' ? [] : ''
        }
      })
      await this.$apollo.mutate({
        mutation: MUTATION_SOCIAL_MEDIA,
        variables: {
          socialMedia: this.socialMedia,
        },
      })
      this.loader = false
      Swal.fire({
        text: 'Dados atualizados!',
        icon: 'success',
        showConfirmButton: false,
        timer: 1000,
        customClass: {
          content: 'content-class',
        },
      })
      window.scrollTo(0, 0)
    },
    restore() {
      this.$apollo.queries.socialMedia.refetch()
      window.scrollTo(0, 0)
    },
    unitsInfo(unitsId) {
      return this.units.filter((unit) => unitsId.includes(unit.id_erp)).map((unit) => unit.name)
    },
    tableUnits(units) {
      if (units.length === 0) return '-'
      const unitsName = this.unitsInfo(units)
      return units.length < 3 ? unitsName.join(', ') : `${unitsName[0]}, ${unitsName[1]}...`
    },
    formattedPhone(phone) {
      const hifenPosition = phone.length === 13 ? 9 : 8
      return `+${phone.substring(0, 2)} (${phone.substring(2, 4)}) ${phone.substring(4, hifenPosition)}-${phone.substring(hifenPosition, phone.length)}`
    },
    addNewContactInfo() {
      this.whatsappInfo = {}
      this.$store.dispatch('setUnavailableUnits', this.unavailableUnits)
      this.contactDialog = true
    },
    editContact(selectedItem) {
      const index = this.socialMedia.whatsapp.findIndex((whatsappItem) => whatsappItem.number === selectedItem.number)
      this.$store.dispatch(
        'setUnavailableUnits',
        this.unavailableUnits.filter((unitId) => !selectedItem.units.includes(unitId))
      )
      this.whatsappInfo = {
        index,
        ...selectedItem,
      }
      this.contactDialog = true
    },
    removeContact(itemToRemove) {
      this.$confirm({
        title: 'Remover número',
        message: 'Tem certeza que deseja remover este número?',
        confirmText: 'Remover',
        confirmColor: 'vermelho-d20',
        cancelText: 'Cancelar',
      })
        .then(() => {
          const index = this.socialMedia.whatsapp.findIndex((whatsappItem) => whatsappItem.number === itemToRemove.number)
          this.socialMedia.whatsapp.splice(index, 1)
        })
        .catch(() => {})
    },
    updateWhatsappList(upsertWhatsappInfo, index) {
      if (index === undefined) {
        if (!this.socialMedia.whatsapp) {
          this.socialMedia.whatsapp = []
        }
        this.socialMedia.whatsapp.push(upsertWhatsappInfo)
        return
      }
      this.$set(this.socialMedia.whatsapp, index, upsertWhatsappInfo)
    },
    prefixValidation(value, socialMedia) {
      let suffix = ''
      if (socialMedia === 'linkedin') {
        suffix = 'company/'
      } else if (socialMedia === 'tiktok') {
        suffix = '@'
      }
      if (!value || value === `https://${socialMedia}.com/${suffix}` || value === `https://www.${socialMedia}.com/${suffix}`) {
        this[`${socialMedia}Link`] = ''
        return
      }
      if (value.includes(`https://${socialMedia}.com/${suffix}`) || value.includes(`https://www.${socialMedia}.com/${suffix}`)) {
        this[`${socialMedia}Link`] = value
      } else {
        this[`${socialMedia}Link`] = `https://${socialMedia}.com/${suffix.concat(value)}`
      }
    },
    getFormatedText(text) {
      return truncate(text, {
        length: 50,
        separator: ' ',
      })
    },
  },
}
</script>

<style lang="scss">
.social-media {
  $background-card-color: $cinza-l90;

  .v-text-field__slot input {
    color: $cinza-0;
  }

  .media-card {
    background-color: $background-card-color;
    margin-bottom: 25px;
  }

  .facebook {
    color: #3b5998;
  }

  .whatsapp {
    color: #25d366;
  }

  .linkedin {
    color: #007bb6;
  }

  .instagram {
    color: $cinza-d10;
  }

  .youtube {
    color: #dd2c28;
  }

  .twitter {
    color: #2ca7e0;
  }

  .tiktok {
    color: #000000;
  }

  .icon {
    width: 22px;
    height: auto;
    margin-right: 14px;
  }

  .table-card {
    background-color: $background-card-color;
  }
}
</style>
